import React, { useState } from "react";
import { Checkbox } from "antd";
import CommonModal from "../../components/Modal";
import { ModalProps } from "../../components/Modal/Modal.types";
import { Icon } from "Components";
import Alert from "PhishingManager/components/Alert";

const ReRunModal : React.FC<ModalProps> = ({
    open,
    onClose,
    onConfirm,
}) => {
    const [checked, setChecked] = useState(false);

    return (
        <CommonModal
            visible={open}
            confirmBtnDisabled={!checked}
            cancelText={"Cancel"}
            modalTitle="Re-run test campaign?"
            confirmText="Resend Test"
            parentClass='re-run-campaign-modal'
            iconType={null}
            onClose={onClose}
            onConfirm={onConfirm}>
                <div>This will resend test emails to your test group.</div>
                <div className="info-section">
                    <span>Before resending, verify:</span>
                    <div className="info-preview">
                        <Icon type="envelope" />
                        <div className="info-preview-content">
                            <span className="title"><strong>Verify sender whitelist</strong></span>
                            <span className="subTitle">Ensure the sending domain is whitelisted.</span>
                        </div>
                    </div>
                </div>
            <Alert 
                iconType="phishingManagerWarningModal"
                subtitle="Resending without changes will likely yield the same result." 
            />
            <div className="checkbox-section">
                <Checkbox  checked={checked} onChange={() => setChecked(!checked)}>
                    I've reviewed the possible issues
                </Checkbox>
            </div>
        </CommonModal>
    );
};

export default ReRunModal;